import { linkToClassPage } from "../../links";

export function linkToClassOverviewPage(classId?: string) {
  return `${linkToClassPage(classId)}/overview`;
}
